<template>
  <div class="appBody bg-white pb-5">
    <van-empty v-if="error" image="error" description="交易信息不存在！"/>
    <div v-else class="text-center font-15 mt-3">
      正在处理支付结果，即将跳转到订单详情页面...
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import {Empty} from "vant";

  Vue.use(Empty);
  export default {
    name: "alipayResultPage",
    data() {
      return {
        traId: '',
        orderId: '',
        error: false
      }
    },
    mounted() {
      this.traId = this.$route.query['out_trade_no'];
      this.getOrderId();
    },
    methods: {
      getOrderId() {
        this.$store.dispatch('getOrderIdByTransaction', {id: this.traId}).then((res) => {
          this.error = false;
          if (res && res.status === 'success' && res.orderId) {
            this.orderId = res.orderId;
            this.$router.push({name:'detailOrder',params: {id: this.orderId},query: {traId: this.traId}});
            // this.$router.push('/order-detail/' + this.orderId);
          }
        }).catch((err) => {
          this.error = true;
        })
      },
    }
  }
</script>

<style scoped>

</style>
